import React, { useState, useEffect } from 'react';
import './index.css';
import { loadSchemaData, getTableNames } from './data/mockData';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Header from './components/Header';

function App() {
  const [selectedTable, setSelectedTable] = useState('bills_master');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tableNames, setTableNames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTables = async () => {
      try {
        const USE_API = true; // Change this to toggle between API and CSV
        const schemaData = await loadSchemaData(USE_API);
        const tables = getTableNames(schemaData);
        setTableNames(tables);
        if (tables.length > 0 && !tables.includes(selectedTable)) {
          setSelectedTable(tables[0]);
        }
      } catch (error) {
        console.error('Failed to load table names:', error);
        // Fallback to default table names
        setTableNames(['bills_master', 'actions', 'amendments', 'committees', 'congressmen', 'cosponsors', 'subjects', 'summaries', 'text_versions', 'related_bills']);
      } finally {
        setLoading(false);
      }
    };
    
    loadTables();
  }, [selectedTable]);

  if (loading) {
    return (
      <div className="flex h-screen bg-marble-900 items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-primary-300">Loading schema data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-marble-900 transition-colors duration-300">
      {/* Sidebar */}
      <Sidebar
        selectedTable={selectedTable}
        setSelectedTable={setSelectedTable}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        tableNames={tableNames}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          setSidebarOpen={setSidebarOpen}
          selectedTable={selectedTable}
        />
        
        {/* Dashboard */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 dark:bg-marble-900 transition-colors duration-300">
          <Dashboard selectedTable={selectedTable} />
        </main>
      </div>
    </div>
  );
}

export default App;
